/**
 * sk-plant-quote.js — „Angebot anfordern" (Großmenge/Projekt) auf den Pflanzen-Produktseiten (snippets/sk-plant-quote.liquid)
 * 1) Hervorhebung: Link → Karte, sobald Menge/Wert/Metafeld es nahelegen (Mengen-View, Flächenrechner, Variante)
 * 2) Dialog (<dialog>, mobil Bottom-Sheet): Positionen aus dem Mengen-View vorbelegt, Freitext-Positionen, Upload (≤ 8 MB, base64)
 * 3) Prüfung im Browser + Feldfehler aus der ERP-Antwort (400 fields), 413/429/Netzfehler inline
 * 4) POST JSON an das ERP (/public/leads/plant-quote) → Erfolgsansicht mit Vorgangsnummer
 * Kein Framework. Lädt nur auf den Pflanzen-Templates.
 */
(function () {
  'use strict';
  if (window.__skPlantQuoteInit) return;
  window.__skPlantQuoteInit = true;

  var MAX_FILE = 8 * 1024 * 1024;
  var FILE_EXT = ['pdf', 'xls', 'xlsx', 'csv', 'jpg', 'jpeg', 'png', 'webp'];
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function readJSON(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function fill(str, map) {
    return String(str || '').replace(/%([A-Z]+)%/g, function (m, k) { return map[k] != null ? map[k] : m; });
  }
  function toInt(v) {
    var n = parseInt(String(v == null ? '' : v).replace(/[^0-9]/g, ''), 10);
    return isFinite(n) ? n : 0;
  }

  function Quote(root) {
    var data = readJSON($('[data-sk-quote-data]', root)) || {};
    this.root = root;
    this.variants = data.variants || {};
    this.i18n = data.i18n || {};
    this.selected = data.selected ? String(data.selected) : '';
    this.minQty = toInt(root.getAttribute('data-min-qty'));
    this.minValue = toInt(root.getAttribute('data-min-value'));
    this.flag = root.getAttribute('data-flag') === 'true';
    this.endpoint = root.getAttribute('data-endpoint');
    this.productId = root.getAttribute('data-product-id') || '';
    this.productTitle = root.getAttribute('data-product-title') || '';
    this.locale = root.getAttribute('data-locale') || document.documentElement.lang || 'de';
    this.dialog = $('[data-sk-quote-dialog]', root);
    this.form = $('[data-sk-quote-form]', this.dialog);
    this.done = $('[data-sk-quote-done]', this.dialog);
    this.linesEl = $('[data-sk-quote-lines]', this.dialog);
    this.emptyEl = $('[data-sk-quote-empty]', this.dialog);
    this.linesErr = $('[data-sk-quote-lines-err]', this.dialog);
    this.summary = $('[data-sk-quote-summary]', this.dialog);
    this.submitBtn = $('[data-sk-quote-submit]', this.dialog);
    this.submitText = $('[data-sk-quote-submit-text]', this.dialog);
    this.fileInput = $('[data-sk-quote-file]', this.dialog);
    this.lines = [];
    this.dirty = false;
    this.busy = false;
    this.seq = 0;
    // Dialog an <body> hängen: nie in einem fremden <form>, keine transform-Eltern
    if (this.dialog && this.dialog.parentNode !== document.body) document.body.appendChild(this.dialog);
    this.bind();
    this.refresh();
  }

  /* ---------- Was ist gerade gewählt? (Mengen-View, Flächenrechner, Variante) ---------- */
  Quote.prototype.snapshot = function () {
    var self = this;
    var picked = [];
    var count = 0;
    var value = 0;
    $$('[data-sk-qm-row]').forEach(function (row) {
      var input = $('[data-sk-qm-qty]', row);
      if (!input) return;
      var q = toInt(input.value);
      if (q <= 0) return;
      var id = row.getAttribute('data-variant-id');
      picked.push({ id: id, q: q });
      count += q;
      value += q * (toInt(row.getAttribute('data-price')) || (self.variants[id] ? self.variants[id].price : 0));
    });
    var area = $('[data-sk-area]');
    if (area) {
      var aq = toInt(($('[data-sk-area-qty]', area) || {}).value);
      var aid = area.getAttribute('data-variant-id');
      if (aq > 0 && aid) {
        picked.push({ id: aid, q: aq });
        count += aq;
        value += aq * (self.variants[aid] ? self.variants[aid].price : 0);
      }
    }
    return { picked: picked, count: count, value: value };
  };

  Quote.prototype.currentVariant = function () {
    var vs = $('variant-selection');
    var id = vs && vs.getAttribute('variant');
    if (!id) {
      var m = /[?&]variant=(\d+)/.exec(window.location.search);
      if (m) id = m[1];
    }
    if (this.lastVariant) id = this.lastVariant;
    return id && this.variants[id] ? String(id) : this.selected;
  };

  Quote.prototype.refresh = function () {
    var snap = this.snapshot();
    var hot = this.flag;
    if (!hot && this.minQty > 0 && snap.count >= this.minQty) hot = true;
    if (!hot && this.minValue > 0 && snap.value >= this.minValue) hot = true;
    // 21.10.2026: Speditionsware allein hebt nicht mehr hervor (Karte nur bei Großmenge/Warenwert/Metafeld)
    this.root.classList.toggle('is-hot', hot);
  };

  /* ---------- Positionen ---------- */
  Quote.prototype.prefill = function () {
    var self = this;
    var snap = this.snapshot();
    var free = this.lines.filter(function (l) { return !l.variant_id; });
    var product = [];
    var src = snap.picked.length ? snap.picked : [{ id: this.currentVariant(), q: 1 }];
    src.forEach(function (p) {
      var v = self.variants[p.id];
      if (!v) return;
      var prev = null;
      product.forEach(function (l) { if (l.variant_id === String(p.id)) prev = l; });
      if (prev) { prev.quantity += p.q; return; }
      product.push({ key: ++self.seq, variant_id: String(p.id), sku: v.sku || '', variant_title: v.title || '', quantity: p.q });
    });
    this.lines = product.concat(free);
  };

  Quote.prototype.lineName = function (l) {
    if (!l.variant_id) return l.free_text || this.i18n.line_free || '';
    var vt = l.variant_title && l.variant_title !== 'Default Title' ? ' – ' + l.variant_title : '';
    return this.productTitle + vt;
  };

  Quote.prototype.renderLines = function () {
    var self = this;
    var ul = this.linesEl;
    ul.innerHTML = '';
    this.lines.forEach(function (l) {
      var li = document.createElement('li');
      li.className = 'sk-plant-quote__line';
      li.setAttribute('data-key', String(l.key));
      var nameCell = document.createElement('div');
      if (l.variant_id) {
        nameCell.className = 'sk-plant-quote__line-name';
        var strong = document.createElement('strong');
        strong.textContent = self.productTitle;
        nameCell.appendChild(strong);
        if (l.variant_title && l.variant_title !== 'Default Title') {
          var span = document.createElement('span');
          span.textContent = l.variant_title;
          nameCell.appendChild(span);
        }
      } else {
        var fid = 'sk-quote-free-' + l.key;
        var lab = document.createElement('label');
        lab.className = 'sk-plant-quote__line-label';
        lab.setAttribute('for', fid);
        lab.textContent = self.i18n.line_free || '';
        var inp = document.createElement('input');
        inp.type = 'text';
        inp.id = fid;
        inp.maxLength = 300;
        inp.value = l.free_text || '';
        inp.placeholder = self.i18n.line_free_ph || '';
        inp.setAttribute('data-sk-quote-free', '');
        inp.addEventListener('input', function () { l.free_text = inp.value; self.dirty = true; self.clearLineErr(li, inp); });
        nameCell.appendChild(lab);
        nameCell.appendChild(inp);
      }
      var qtyCell = document.createElement('div');
      var qid = 'sk-quote-qty-' + l.key;
      var ql = document.createElement('label');
      ql.className = 'sk-plant-quote__line-label';
      ql.setAttribute('for', qid);
      ql.textContent = self.i18n.line_qty || '';
      var q = document.createElement('input');
      q.type = 'number';
      q.id = qid;
      q.min = '1';
      q.max = '99999';
      q.step = '1';
      q.inputMode = 'numeric';
      q.value = String(l.quantity || 1);
      q.setAttribute('data-sk-quote-qty', '');
      q.addEventListener('input', function () { l.quantity = toInt(q.value); self.dirty = true; self.clearLineErr(li, q); });
      qtyCell.appendChild(ql);
      qtyCell.appendChild(q);
      var x = document.createElement('button');
      x.type = 'button';
      x.className = 'sk-plant-quote__line-x';
      x.setAttribute('aria-label', fill(self.i18n.line_remove, { NAME: self.lineName(l) }));
      x.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
      x.addEventListener('click', function () {
        self.lines = self.lines.filter(function (o) { return o.key !== l.key; });
        self.dirty = true;
        self.renderLines();
        var next = $('[data-sk-quote-add]', self.dialog);
        if (next) next.focus();
      });
      li.appendChild(nameCell);
      li.appendChild(qtyCell);
      li.appendChild(x);
      ul.appendChild(li);
    });
    this.emptyEl.hidden = this.lines.length > 0;
  };

  Quote.prototype.clearLineErr = function (li, input) {
    input.removeAttribute('aria-invalid');
    var e = $('.sk-plant-quote__line-err', li);
    if (e && !$('[aria-invalid="true"]', li)) e.remove();
  };

  /* ---------- Dialog ---------- */
  Quote.prototype.open = function (opener) {
    this.opener = opener || null;
    if (!this.dirty) this.prefill();
    this.form.hidden = false;
    this.done.hidden = true;
    this.renderLines();
    this.syncType();
    this.syncCountry();
    document.body.classList.add('sk-quote-open');
    if (typeof this.dialog.showModal === 'function') {
      if (!this.dialog.open) this.dialog.showModal();
    } else {
      this.dialog.setAttribute('open', '');
    }
  };

  Quote.prototype.close = function () {
    // natives close() feuert „close" → afterClose; ohne Dialog-API direkt aufräumen
    if (this.dialog.open && typeof this.dialog.close === 'function') { this.dialog.close(); return; }
    this.dialog.removeAttribute('open');
    this.afterClose();
  };

  Quote.prototype.afterClose = function () {
    document.body.classList.remove('sk-quote-open');
    if (this.sent) {
      // nach dem Absenden: beim nächsten Öffnen leeres Formular
      this.form.reset();
      this.lines = [];
      this.dirty = false;
      this.sent = false;
      this.clearFile();
      this.clearErrors();
    }
    if (this.opener && document.contains(this.opener)) this.opener.focus();
  };

  Quote.prototype.syncType = function () {
    var biz = (($('input[name="customer_type"]:checked', this.form) || {}).value || 'gewerblich') === 'gewerblich';
    var wrap = $('[data-sk-quote-company]', this.form);
    if (wrap) wrap.hidden = !biz;
    var c = $('[data-sk-quote-input="company"]', this.form);
    if (c) c.required = biz;
  };

  Quote.prototype.syncCountry = function () {
    var at = (($('[data-sk-quote-input="country"]', this.form) || {}).value || 'DE') === 'AT';
    var plz = $('[data-sk-quote-input="plz"]', this.form);
    if (plz) {
      plz.maxLength = at ? 4 : 5;
      plz.placeholder = at ? '1010' : '12345';
    }
  };

  /* ---------- Datei ---------- */
  Quote.prototype.clearFile = function () {
    if (this.fileInput) this.fileInput.value = '';
    var sel = $('[data-sk-quote-file-sel]', this.form);
    if (sel) sel.hidden = true;
  };

  Quote.prototype.fileError = function (f) {
    if (!f) return '';
    var ext = (f.name.split('.').pop() || '').toLowerCase();
    if (FILE_EXT.indexOf(ext) === -1) return this.i18n.err_file_type;
    if (f.size > MAX_FILE) return this.i18n.err_file_size;
    return '';
  };

  function readBase64(file) {
    return new Promise(function (resolve, reject) {
      var r = new FileReader();
      r.onload = function () {
        var s = String(r.result || '');
        resolve(s.indexOf(',') > -1 ? s.slice(s.indexOf(',') + 1) : s);
      };
      r.onerror = function () { reject(r.error); };
      r.readAsDataURL(file);
    });
  }

  /* ---------- Fehler ---------- */
  Quote.prototype.errEl = function (input) {
    return input && input.id ? document.getElementById(input.id + '-err') : null;
  };

  Quote.prototype.setError = function (input, msg) {
    if (!input) return;
    var box = input.type === 'checkbox' ? document.getElementById(this.root.id + '-consent-err') : this.errEl(input);
    input.setAttribute('aria-invalid', 'true');
    if (box) {
      box.textContent = msg;
      box.hidden = false;
      input.setAttribute('aria-describedby', box.id);
    }
  };

  Quote.prototype.clearError = function (input) {
    if (!input) return;
    input.removeAttribute('aria-invalid');
    var box = input.type === 'checkbox' ? document.getElementById(this.root.id + '-consent-err') : this.errEl(input);
    if (box) { box.hidden = true; box.textContent = ''; }
  };

  Quote.prototype.clearErrors = function () {
    var self = this;
    $$('[aria-invalid="true"]', this.form).forEach(function (el) { self.clearError(el); el.removeAttribute('aria-invalid'); });
    $$('.sk-plant-quote__line-err', this.form).forEach(function (el) { el.remove(); });
    $$('.sk-plant-quote__err', this.form).forEach(function (el) { el.hidden = true; el.textContent = ''; });
    this.summary.hidden = true;
  };

  Quote.prototype.lineError = function (index, which, msg) {
    var li = this.linesEl.children[index];
    if (!li) return null;
    var input = $(which === 'free' ? '[data-sk-quote-free]' : '[data-sk-quote-qty]', li) || $('[data-sk-quote-qty]', li);
    if (input) input.setAttribute('aria-invalid', 'true');
    if (!$('.sk-plant-quote__line-err', li)) {
      var p = document.createElement('p');
      p.className = 'sk-plant-quote__line-err';
      p.id = 'sk-quote-line-err-' + li.getAttribute('data-key');
      p.textContent = msg;
      li.appendChild(p);
      if (input) input.setAttribute('aria-describedby', p.id);
    }
    return input;
  };

  Quote.prototype.showSummary = function (msg) {
    this.summary.textContent = msg;
    this.summary.hidden = false;
  };

  Quote.prototype.validate = function () {
    var f = this.form;
    var i = this.i18n;
    var first = null;
    var self = this;
    function bad(input, msg) { self.setError(input, msg); if (!first) first = input; }
    this.clearErrors();
    var biz = (($('input[name="customer_type"]:checked', f) || {}).value) === 'gewerblich';
    var company = $('[data-sk-quote-input="company"]', f);
    if (biz && company.value.trim().length < 2) bad(company, i.err_required);
    var name = $('[data-sk-quote-input="name"]', f);
    if (name.value.trim().length < 2) bad(name, i.err_required);
    var email = $('[data-sk-quote-input="email"]', f);
    if (!email.value.trim()) bad(email, i.err_required);
    else if (!EMAIL_RE.test(email.value.trim())) bad(email, i.err_email);
    var at = $('[data-sk-quote-input="country"]', f).value === 'AT';
    var plz = $('[data-sk-quote-input="plz"]', f);
    var pv = plz.value.trim();
    if (!(at ? /^\d{4}$/ : /^\d{5}$/).test(pv)) bad(plz, at ? i.err_plz_at : i.err_plz_de);
    // Positionen
    if (!this.lines.length) {
      this.linesErr.textContent = i.err_lines;
      this.linesErr.hidden = false;
      if (!first) first = $('[data-sk-quote-add]', f);
    }
    this.lines.forEach(function (l, idx) {
      if (!l.variant_id && !(l.free_text || '').trim()) {
        var inp = self.lineError(idx, 'free', i.err_required);
        if (!first) first = inp;
      } else if (!(l.quantity >= 1 && l.quantity <= 99999)) {
        var qi = self.lineError(idx, 'qty', i.err_qty);
        if (!first) first = qi;
      }
    });
    var file = this.fileInput && this.fileInput.files && this.fileInput.files[0];
    var fe = this.fileError(file);
    if (fe) bad(this.fileInput, fe);
    var consent = $('[data-sk-quote-input="consent_terms"]', f);
    if (!consent.checked) bad(consent, i.err_consent);
    if (first) {
      this.showSummary(i.err_check);
      first.focus();
      return false;
    }
    return true;
  };

  /* Feldfehler aus der ERP-Antwort (400 → fields: ["email", "lines.0.quantity", …]) */
  Quote.prototype.serverFields = function (fields) {
    var f = this.form;
    var i = this.i18n;
    var self = this;
    var first = null;
    (fields || []).forEach(function (path) {
      var p = String(path).split('.');
      var input = null;
      var msg = i.err_required;
      switch (p[0]) {
        case 'email': input = $('[data-sk-quote-input="email"]', f); msg = i.err_email; break;
        case 'plz':
        case 'country': input = $('[data-sk-quote-input="plz"]', f); msg = $('[data-sk-quote-input="country"]', f).value === 'AT' ? i.err_plz_at : i.err_plz_de; break;
        case 'company': input = $('[data-sk-quote-input="company"]', f); break;
        case 'name': input = $('[data-sk-quote-input="name"]', f); break;
        case 'phone': input = $('[data-sk-quote-input="phone"]', f); break;
        case 'wish_date': input = $('[data-sk-quote-input="wish_date"]', f); break;
        case 'message': input = $('[data-sk-quote-input="message"]', f); break;
        case 'consent_terms': input = $('[data-sk-quote-input="consent_terms"]', f); msg = i.err_consent; break;
        case 'attachment': input = self.fileInput; msg = i.err_file_type; break;
        case 'lines': {
          var idx = parseInt(p[1], 10);
          if (isFinite(idx)) {
            var which = p[2] === 'free_text' ? 'free' : 'qty';
            var li = self.lineError(idx, which, which === 'free' ? i.err_required : i.err_qty);
            if (li && !first) first = li;
          } else {
            self.linesErr.textContent = i.err_lines;
            self.linesErr.hidden = false;
          }
          return;
        }
        default: return;
      }
      if (input) { self.setError(input, msg); if (!first) first = input; }
    });
    this.showSummary(i.err_check);
    (first || this.summary).focus();
  };

  Quote.prototype.setBusy = function (on) {
    this.busy = on;
    this.submitBtn.setAttribute('aria-busy', on ? 'true' : 'false');
    this.submitBtn.disabled = on;
    this.submitText.textContent = on ? this.i18n.sending : this.i18n.submit;
  };

  Quote.prototype.submit = function () {
    var self = this;
    if (this.busy) return;
    if (!this.validate()) return;
    var f = this.form;
    var val = function (k) { var el = $('[data-sk-quote-input="' + k + '"]', f); return el ? el.value.trim() : ''; };
    var type = ($('input[name="customer_type"]:checked', f) || {}).value || 'gewerblich';
    var payload = {
      customer_type: type,
      company: type === 'gewerblich' ? val('company') : '',
      name: val('name'),
      email: val('email'),
      phone: val('phone'),
      country: val('country') || 'DE',
      plz: val('plz'),
      wish_date: val('wish_date'),
      truck_access: ($('input[name="truck_access"]:checked', f) || {}).value || 'unklar',
      message: val('message'),
      lines: this.lines.map(function (l) {
        if (l.variant_id) {
          return { variant_id: l.variant_id, sku: l.sku, product_title: self.productTitle, variant_title: l.variant_title, quantity: l.quantity };
        }
        return { free_text: (l.free_text || '').trim(), quantity: l.quantity };
      }),
      attachment: null,
      page_url: window.location.origin + window.location.pathname,
      product_id: this.productId,
      locale: this.locale,
      consent_terms: true,
      honeypot: (($('[data-sk-quote-hp]', f) || {}).value || '')
    };
    var file = this.fileInput && this.fileInput.files && this.fileInput.files[0];
    this.setBusy(true);
    var ready = file ? readBase64(file).then(function (b64) {
      payload.attachment = { filename: file.name, content_type: file.type || 'application/octet-stream', data_base64: b64 };
    }) : Promise.resolve();
    ready.then(function () {
      return fetch(self.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      });
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (data) { return { status: r.status, data: data || {} }; });
    }).then(function (res) {
      self.setBusy(false);
      if (res.status >= 200 && res.status < 300 && res.data.success) {
        self.success(res.data.number || '');
        return;
      }
      if (res.status === 413 || res.data.error === 'attachment_too_large') {
        self.setError(self.fileInput, self.i18n.err_file_size);
        self.showSummary(self.i18n.err_check);
        self.fileInput.focus();
        return;
      }
      if (res.status === 429) { self.showSummary(self.i18n.err_rate); self.summary.focus(); return; }
      if (res.status === 400 && res.data.fields && res.data.fields.length) { self.serverFields(res.data.fields); return; }
      self.showSummary(self.i18n.err_generic);
      self.summary.focus();
    }).catch(function () {
      self.setBusy(false);
      self.showSummary(self.i18n.err_network);
      self.summary.focus();
    });
  };

  Quote.prototype.success = function (number) {
    this.sent = true;
    this.form.hidden = true;
    this.done.hidden = false;
    $('[data-sk-quote-done-text]', this.done).textContent = fill(this.i18n.success_text, { VALUE: number || '–' });
    this.done.focus();
  };

  /* ---------- Ereignisse ---------- */
  Quote.prototype.bind = function () {
    var self = this;
    $$('[data-sk-quote-open]', this.root).forEach(function (b) {
      b.addEventListener('click', function () { self.open(b); });
    });
    $$('[data-sk-quote-close]', this.dialog).forEach(function (b) {
      b.addEventListener('click', function () { self.close(); });
    });
    this.dialog.addEventListener('close', function () { self.afterClose(); });
    // Klick auf den abgedunkelten Hintergrund schließt
    this.dialog.addEventListener('click', function (e) { if (e.target === self.dialog) self.close(); });
    this.form.addEventListener('submit', function (e) { e.preventDefault(); self.submit(); });
    this.form.addEventListener('change', function (e) {
      var t = e.target;
      if (t.name === 'customer_type') self.syncType();
      if (t.name === 'country') { self.syncCountry(); self.clearError($('[data-sk-quote-input="plz"]', self.form)); }
    });
    this.form.addEventListener('input', function (e) {
      var t = e.target;
      if (t.matches && t.matches('[data-sk-quote-input]') && t.getAttribute('aria-invalid') === 'true') self.clearError(t);
    });
    $('[data-sk-quote-input="consent_terms"]', this.form).addEventListener('change', function (e) {
      if (e.target.checked) self.clearError(e.target);
    });
    $('[data-sk-quote-add]', this.form).addEventListener('click', function () {
      self.lines.push({ key: ++self.seq, free_text: '', quantity: 1 });
      self.dirty = true;
      self.linesErr.hidden = true;
      self.renderLines();
      var last = self.linesEl.lastElementChild;
      var inp = last && $('[data-sk-quote-free]', last);
      if (inp) inp.focus();
    });
    if (this.fileInput) {
      this.fileInput.addEventListener('change', function () {
        var file = self.fileInput.files && self.fileInput.files[0];
        var sel = $('[data-sk-quote-file-sel]', self.form);
        self.clearError(self.fileInput);
        if (!file) { if (sel) sel.hidden = true; return; }
        var fe = self.fileError(file);
        if (fe) { self.setError(self.fileInput, fe); }
        $('[data-sk-quote-file-name]', self.form).textContent = file.name;
        if (sel) sel.hidden = false;
      });
      $('[data-sk-quote-file-x]', this.form).addEventListener('click', function () {
        self.clearFile();
        self.clearError(self.fileInput);
        self.fileInput.focus();
      });
    }
    // Hervorhebung nachführen (Mengen-View, Flächenrechner, Größenwechsel)
    var raf = 0;
    var schedule = function () {
      if (raf) return;
      raf = window.requestAnimationFrame(function () { raf = 0; self.refresh(); });
    };
    document.addEventListener('input', schedule, true);
    document.addEventListener('change', schedule, true);
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-sk-qm-step], [data-sk-area-step], [data-sk-hedge-apply], [data-sk-qm-tab]')) schedule();
    }, true);
    document.addEventListener('sk-plant:variant', function (e) {
      if (e.detail && e.detail.id) self.lastVariant = String(e.detail.id);
      schedule();
    });
    $$('variant-selection').forEach(function (vs) {
      vs.addEventListener('variant-change', function (e) {
        var v = e.detail && e.detail.variant;
        if (v && v.id) self.lastVariant = String(v.id);
        schedule();
      });
    });
  };

  function init() {
    $$('[data-sk-quote]').forEach(function (root) {
      if (root.__skQuote) return;
      root.__skQuote = new Quote(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
